import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { PaymentIntentFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/PaymentIntentFactory';

interface NextActionCompleteOnboardingProps {
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
  onOpenMerchantPos: () => void;
}

export const NextActionCompleteOnboarding = ({
  paymentMethodDetailEntity,
  onOpenMerchantPos,
}: NextActionCompleteOnboardingProps) => {
  return (
    <PaymentIntentFactory
      paymentMethodDetailEntity={paymentMethodDetailEntity}
      onOpenMerchantPos={onOpenMerchantPos}
    />
  );
};
